/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PartnerData } from './PartnerData';
import {
    PartnerDataFromJSON,
    PartnerDataFromJSONTyped,
    PartnerDataToJSON,
} from './PartnerData';

/**
 * 
 * @export
 * @interface PrebookingUiLocationConfig
 */
export interface PrebookingUiLocationConfig {
    /**
     * 
     * @type {number}
     * @memberof PrebookingUiLocationConfig
     */
    maxBookingDays: number;
    /**
     * 
     * @type {Date}
     * @memberof PrebookingUiLocationConfig
     */
    earliestPrebookingPossibleAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof PrebookingUiLocationConfig
     */
    latestPrebookingPossibleAt: Date;
    /**
 * 
 * @type {Date}
 * @memberof PrebookingUiLocationConfig
 */
    earliestPrebookingPossibleAtMeta: Date;
    /**
     * 
     * @type {Date}
     * @memberof PrebookingUiLocationConfig
     */
    latestPrebookingPossibleAtMeta: Date;
    /**
     * 
     * @type {string}
     * @memberof PrebookingUiLocationConfig
     */
    defaultVehicleCategory: string;
    /**
     * 
     * @type {number}
     * @memberof PrebookingUiLocationConfig
     */
    cancellationNoFeeTimeoutHours: number;
    /**
     * 
     * @type {number}
     * @memberof PrebookingUiLocationConfig
     */
    driverNotValidatedTimeout: number;
    /**
     * 
     * @type {boolean}
     * @memberof PrebookingUiLocationConfig
     */
    isDevelopment: boolean;
    /**
     * 
     * @type {PartnerData}
     * @memberof PrebookingUiLocationConfig
     */
    partner?: PartnerData;
}

/**
 * Check if a given object implements the PrebookingUiLocationConfig interface.
 */
export function instanceOfPrebookingUiLocationConfig(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "maxBookingDays" in value;
    isInstance = isInstance && "earliestPrebookingPossibleAt" in value;
    isInstance = isInstance && "latestPrebookingPossibleAt" in value;
    isInstance = isInstance && "earliestPrebookingPossibleAtMeta" in value;
    isInstance = isInstance && "latestPrebookingPossibleAtMeta" in value;
    isInstance = isInstance && "defaultVehicleCategory" in value;
    isInstance = isInstance && "cancellationNoFeeTimeoutHours" in value;
    isInstance = isInstance && "driverNotValidatedTimeout" in value;
    isInstance = isInstance && "isDevelopment" in value;

    return isInstance;
}

export function PrebookingUiLocationConfigFromJSON(json: any): PrebookingUiLocationConfig {
    return PrebookingUiLocationConfigFromJSONTyped(json, false);
}

export function PrebookingUiLocationConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrebookingUiLocationConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'maxBookingDays': json['maxBookingDays'],
        'earliestPrebookingPossibleAt': (new Date(json['earliestPrebookingPossibleAt'])),
        'latestPrebookingPossibleAt': (new Date(json['latestPrebookingPossibleAt'])),
        'earliestPrebookingPossibleAtMeta': (new Date(json['earliestPrebookingPossibleAtMeta'])),
        'latestPrebookingPossibleAtMeta': (new Date(json['latestPrebookingPossibleAtMeta'])),
        'defaultVehicleCategory': json['defaultVehicleCategory'],
        'cancellationNoFeeTimeoutHours': json['cancellationNoFeeTimeoutHours'],
        'driverNotValidatedTimeout': json['driverNotValidatedTimeout'],
        'isDevelopment': json['isDevelopment'],
        'partner': !exists(json, 'partner') ? undefined : PartnerDataFromJSON(json['partner']),
    };
}

export function PrebookingUiLocationConfigToJSON(value?: PrebookingUiLocationConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'maxBookingDays': value.maxBookingDays,
        'earliestPrebookingPossibleAt': (value.earliestPrebookingPossibleAt.toISOString()),
        'latestPrebookingPossibleAt': (value.latestPrebookingPossibleAt.toISOString()),
        'earliestPrebookingPossibleAtMeta': (value.earliestPrebookingPossibleAtMeta.toISOString()),
        'latestPrebookingPossibleAtMeta': (value.latestPrebookingPossibleAtMeta.toISOString()),
        'defaultVehicleCategory': value.defaultVehicleCategory,
        'cancellationNoFeeTimeoutHours': value.cancellationNoFeeTimeoutHours,
        'driverNotValidatedTimeout': value.driverNotValidatedTimeout,
        'isDevelopment': value.isDevelopment,
        'partner': PartnerDataToJSON(value.partner),
    };
}

